import { Directive, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[wlTrimInput][ngModel]',
  standalone: false,
})
export class TrimInputDirective {
  constructor(@Self() private ngControl: NgControl) {}

  @HostListener('blur')
  onBlur() {
    const value = this.ngControl.value;
    if (typeof value === 'string') {
      this.ngControl.control.setValue(value.trim());
    }
  }
}
